module.exports = __webpack_public_path__ + "img/ZWF_Practice.85bd94a1.jpg";